import { FC, ReactNode } from 'react';
import classnames from 'classnames/bind';
import { InputNumber } from 'rsuite';
import { RsInputSize, sizeMap } from './size';
import styles from './input.module.scss';

const cx = classnames.bind(styles);

interface RsNumberInputProps {
  prefix?: ReactNode;
  num: string;
  onChange: (num: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  className?: string;
  showBtn?: boolean;
  disabled?: boolean;
  scrollable?: boolean;
  size?: RsInputSize;
}

export const RsNumberInput: FC<RsNumberInputProps> = ({
  prefix = 'NTD',
  num,
  onChange = () => undefined,
  onBlur = () => undefined,
  placeholder = '',
  className,
  showBtn = false,
  disabled = false,
  scrollable = false,
  size = RsInputSize.LARGE,
}) => {
  const handleChange = (v) => {
    if (isNaN(v) || Number(v) < 0) return;
    onChange(v);
  };
  const classNames = cx('RsNumberInput', className, `${sizeMap[size]}`, {
    'no-btn': !showBtn,
  });
  return (
    <InputNumber
      prefix={prefix}
      value={num}
      onChange={handleChange}
      className={classNames}
      disabled={disabled}
      scrollable={scrollable}
      placeholder={placeholder}
      onBlur={onBlur}
    />
  );
};
